import axios from 'axios';

import { baseURL } from '@src/configuration/constants';

const client = axios.create({
  baseURL,
});

export default client;
